// Removing the fake captcha element from the form
window.removeFakeCaptcha = () => {
    // Selecting and removing the fake captcha field
    document.querySelector('.captcha-fake-field').remove();
}
